export default __webpack_public_path__ + "static/media/forward-icon.378ef8f6.svg";